import React from "react";
import { Helmet } from "react-helmet";

import { Navbar, Landing } from "../../components";
import { headerData } from "../../data/headerData";

function Main() {
  return (
    <div>
      <Helmet>
        <title>{headerData.name} - Software Engineer</title>
      </Helmet>
      <Navbar />
      <Landing />
    </div>
  );
}

export default Main;
